export const HANDLE_FETCH_STUDENT_CALENDAR_WORKSHEETS = "HANDLE_FETCH_STUDENT_CALENDAR_WORKSHEETS";

export interface IHandleFetchStudentCalendarWorksheets {
  type: typeof HANDLE_FETCH_STUDENT_CALENDAR_WORKSHEETS;
}

export const HANDLE_FETCH_STUDENT_WORKSHEETS = "HANDLE_FETCH_STUDENT_WORKSHEETS";

export interface IHandleFetchStudentWorksheets {
  type: typeof HANDLE_FETCH_STUDENT_WORKSHEETS;
}

export const HANDLE_ASSIGN_STUDENT_WORKSHEETS = "HANDLE_ASSIGN_STUDENT_WORKSHEETS";

export interface IHandleAssignStudentWorksheets {
  type: typeof HANDLE_ASSIGN_STUDENT_WORKSHEETS;
  payload: NewWorksheet;
  source: Source;
}

export const HANDLE_UNASSIGN_STUDENT_WORKSHEETS = "HANDLE_UNASSIGN_STUDENT_WORKSHEETS";

/**
 * @params: payload: array of worksheets ids
 * */
export interface IHandleUnassignStudentWorksheets {
  type: typeof HANDLE_UNASSIGN_STUDENT_WORKSHEETS;
  payload: string[];
}

export const HANDLE_EXCUSE_STUDENT_WORKSHEET_LATENESS = "HANDLE_EXCUSE_STUDENT_WORKSHEET_LATENESS";

export interface IHandleExcuseStudentWorksheetLateness {
  type: typeof HANDLE_EXCUSE_STUDENT_WORKSHEET_LATENESS;
  payload: WorksheetExcuseLatenessPayload[];
}

export const HANDLE_MARK_ALL_WORKSHEET_FLAGS_REVIEWED = "HANDLE_MARK_ALL_WORKSHEET_FLAGS_REVIEWED";

export interface IHandleMarkAllWorksheetFlagsReviewed {
  type: typeof HANDLE_MARK_ALL_WORKSHEET_FLAGS_REVIEWED;
  payload: string[];
  single: boolean;
}

export const HANDLE_RESET_STUDENT_WORKSHEETS = "HANDLE_RESET_STUDENT_WORKSHEETS";

export interface IHandleResetStudentWorksheets {
  type: typeof HANDLE_RESET_STUDENT_WORKSHEETS;
  payload: string[];
}

export const HANDLE_SUBMIT_BULK_WORKSHEET_ANSWERS = "HANDLE_SUBMIT_BULK_WORKSHEET_ANSWERS";

export interface IHandleSubmitBulkWorksheetAnswers {
  type: typeof HANDLE_SUBMIT_BULK_WORKSHEET_ANSWERS;
  payload: WorksheetBulkAnswersPayload;
}

export const HANDLE_RESCHEDULE_WORKSHEETS = "HANDLE_RESCHEDULE_WORKSHEETS";

export interface IRescheduleWorksheets {
  type: typeof HANDLE_RESCHEDULE_WORKSHEETS;
  payload: WorksheetReschedulePayload[];
  source: "list" | "calendar";
}

export const SET_STUDENT_WORKSHEETS = "SET_STUDENT_WORKSHEETS";

export interface ISetStudentWorksheets {
  type: typeof SET_STUDENT_WORKSHEETS;
  payload: Worksheet[];
}

export const SET_ACTIVE_WORKSHEET = "SET_ACTIVE_WORKSHEET";

export interface ISetActiveWorksheet {
  type: typeof SET_ACTIVE_WORKSHEET;
  payload: Worksheet;
}

export const HANDLE_UPDATE_STUDENT_WORKSHEET_PROBLEM_FLAG_STATUS =
  "HANDLE_UPDATE_STUDENT_WORKSHEET_PROBLEM_FLAG_STATUS";

export interface IHandleUpdateStudentWorksheetProblemFlagStatus {
  type: typeof HANDLE_UPDATE_STUDENT_WORKSHEET_PROBLEM_FLAG_STATUS;
  payload: UpdateStudentWorksheetProblemFlagStatusPayload;
}

export const SET_STUDENT_WORKSHEET_PROBLEM_FLAG = "SET_STUDENT_WORKSHEET_PROBLEM_FLAG";

export interface ISetStudentWorksheetProblemFlag {
  type: typeof SET_STUDENT_WORKSHEET_PROBLEM_FLAG;
  payload: UpdateStudentWorksheetProblemFlagStatusPayload;
}

export const HANDLE_START_STUDENT_WORKSHEET = "HANDLE_START_STUDENT_WORKSHEET";

export interface IHandleStartStudentWorksheet {
  type: typeof HANDLE_START_STUDENT_WORKSHEET;
}

export const HANDLE_FETCH_STUDENT_WORKSHEETS_BY_CATEGORIES =
  "HANDLE_FETCH_STUDENT_WORKSHEETS_BY_CATEGORIES";

export interface IHandleFetchStudentWorksheetsByCategories {
  type: typeof HANDLE_FETCH_STUDENT_WORKSHEETS_BY_CATEGORIES;
  payload: string[];
}
